export { default } from "./Form6";
export { default as Form_6 } from "./Form6";
export * from "./types";
export * from "./components";
export * from "./hooks";

